import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'

function App({ data }) {
  const [radius, setRadius] = useState(100)
  const [showLabel, setShowLabel] = useState(false)

  const handleWindowSize = () => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      setRadius(140)
    } else {
      setRadius(100)
    }

    if (window.matchMedia('(min-width: 768px)').matches) {
      setShowLabel(true)
    } else {
      setShowLabel(false)
    }
  }

  useEffect(() => {
    handleWindowSize()

    window.addEventListener('resize', handleWindowSize)

    return () => window.removeEventListener('resize', handleWindowSize)
  }, [handleWindowSize])

  return (
    <>
      <div className="relative h-64 lg:h-96">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              dataKey="value"
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={radius * 0.7}
              outerRadius={radius}
              fill="#8884d8"
              label={showLabel ? (entry) => entry.name : false}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div className="text-brand-blue pie-chart-title">Investment Asset Mix</div>
      </div>

      {!showLabel && (
        <div className="text-center">
          {data.map((entry, index) => (
            <div key={`legend-${index}`} style={{ color: entry.color }}>
              {entry.name}
            </div>
          ))}
        </div>
      )}
    </>
  )
}

App.propTypes = {
  data: PropTypes.array,
}

export default App
